import React, { Component } from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';

// Routing
import routes from '~/apiRouter';

// Components
import Loader from '~/components/ui/Loader';
import AnchorMenu from './AnchorMenu';
import RenderBlocks from './RenderBlocks';
import AddBlockBtn from './AddBlockBtn';
import AddBlockPopup from './AddBlockPopup';
import BlockFormPopup from './BlockFormPopup';
import Actions from './Actions';
import fakeData from '~/data/fakeEditor';
import ImportStateFromDebug from '~/components/editor/ImportStateFromDebug';

// Umakhi = "Constructor" on Zuulu language
export default class Umakhi extends Component {
  state = {
    data: [],
    loading: true,
    error: null,
    disciplines: [],
    disciplinesFree: [],
  };

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate() {
    drawDiagrams();
  }

  loadRefences() {
    const { page } = this.props;
    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };
    fetch(`${routes.designer.references}${page}`, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          this.setState({
            disciplines: response.data.EVENT_PAGE.DISCIPLINE,
            disciplinesFree: response.data.EVENT_PAGE.DISCIPLINE_FREE,
            loading: false,
          });
        } else {
          this.setState({
            error: response.errors
              ? response.errors.map(e => e.message)
              : ['Ошибка загрузки данных по странице'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки страницы с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  loadData() {
    const { page } = this.props;
    if (!page) {
      this.setState({ loading: false });
      return;
    }

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };
    fetch(`${routes.designer.update}${page}`, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          this.setState({
            data:
              response.data.PROPERTY_DESIGNER_VALUE?.filter(b => b != null) ||
              [],
            // loading: false,
          });
          this.loadRefences();
        } else {
          this.setState({
            error: response.errors
              ? response.errors.map(e => e.message)
              : ['Ошибка загрузки данных по странице'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки страницы с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  addBlock(block, parent = null, aside = false) {
    const newData = JSON.parse(JSON.stringify(this.state.data));

    if (parent == null) {
      // If block is first level
      newData.push(block);
    } else {
      // If block is child
      newData.forEach((b, index) => {
        if (b.type == parent.type && b.sort == parent.sort) {
          if (aside) {
            // If aside block
            b.content.aside.push(block);
          } else {
            // If not aside
            b.content[parent.group][parent.itemIndex].children.push(block);
          }
        }
      });
    }

    // Sort blocks and set new sort values
    newData.sort((a, b) => (a.sort > b.sort ? 1 : b.sort > a.sort ? -1 : 0));
    newData.forEach((block, index) => {
      newData[index].sort = (index + 1) * 10;
    });

    this.setState({ data: newData });
    $.magnificPopup.close();
  }

  openAddPopup(block = null, parentBlock = null, aside = false, sort = null) {
    const { data, disciplinesFree, disciplines } = this.state;
    const parent = this;

    if (block) {
      // Open one block form
      // TODO: Remove set timeout (dont working without it)
      if (sort == null) {
        sort = (data.length + 1) * 10;
      }
      if (parentBlock != null) {
        const parentItem = data
          .filter(
            b => b.type === parentBlock.type && b.sort === parentBlock.sort,
          )
          .pop();

        if (aside) {
          sort = (parentItem.content.aside.length + 1) * 10;
        } else {
          sort =
            (parentItem.content[parentBlock.group][parentBlock.itemIndex]
              .children.length +
              1) *
            10;
        }
      }
      $.magnificPopup.close();
      setTimeout(function() {
        $.magnificPopup.open({
          items: {
            src: '#popup',
            type: 'inline',
          },
          removalDelay: 250,
          closeOnBgClick: false,
          enableEscapeKey: false,
          mainClass: 'mfp-anim',
          callbacks: {
            open() {
              // Disciplines in props need only in CTA blocks
              render(
                <BlockFormPopup
                  disciplines={{ all: disciplines, free: disciplinesFree }}
                  parent={parentBlock}
                  block={block}
                  sort={sort}
                  onSave={block => {
                    if (
                      block.content?.group_content?.every(
                        content => content?.reference?.length === 0,
                      )
                    ) {
                      alert('Введите код дисциплины из CRM');
                      return;
                    }
                    parent.addBlock(block, parentBlock, aside);
                  }}
                />,
                $('#popup')[0],
              );
            },
            close() {
              render(<div />, $('#popup')[0]);
            },
          },
        });
      }, 500);
    } else {
      // Open block library
      $.magnificPopup.open({
        items: {
          src: '#popup',
          type: 'inline',
        },
        removalDelay: 250,
        closeOnBgClick: false,
        mainClass: 'mfp-anim',
        callbacks: {
          open() {
            render(
              <AddBlockPopup
                aside={aside}
                parent={parentBlock}
                onClick={block =>
                  parent.openAddPopup(block, parentBlock, aside, sort)
                }
              />,
              $('#popup')[0],
            );
          },
          close() {
            render(<div />, $('#popup')[0]);
          },
        },
      });
    }
  }

  editBlock(block, parent, aside) {
    const { data } = this.state;
    const newData = JSON.parse(JSON.stringify(data));

    if (parent) {
      newData.forEach((b, index) => {
        if (b.sort === parent.block.sort && b.type === parent.block.type) {
          if (aside) {
            // Aside
            newData[index].content.aside.forEach((asideBlock, asideIndex) => {
              if (
                asideBlock.sort == block.sort &&
                asideBlock.type == block.type
              ) {
                newData[index].content.aside[asideIndex] = block;
              }
            });
          } else {
            // Children
            newData[index].content[parent.group][
              parent.indexItem
            ].children.forEach((childBlock, childIndex) => {
              if (
                childBlock.sort == block.sort &&
                childBlock.type == block.type
              ) {
                newData[index].content[parent.group][parent.indexItem].children[
                  childIndex
                ] = block;
              }
            });
          }
        }
      });
    } else {
      newData.forEach((b, index) => {
        if (b.sort === block.sort && b.type === block.type) {
          newData[index] = block;
        }
      });
    }

    this.setState({ data: newData });
    $.magnificPopup.close();
  }

  onBlockAction(type, sort, action, group, itemIndex, parentItem, aside) {
    const parent = this;
    const { data, disciplines, disciplinesFree } = this.state;
    let newData = JSON.parse(JSON.stringify(data));
    const globalData = JSON.parse(JSON.stringify(data));

    // If children actions
    if (parentItem) {
      const parentBlock = newData
        .filter(
          b =>
            b.type === parentItem.block.type &&
            b.sort === parentItem.block.sort,
        )
        .pop();

      if (action == 'aside' || aside) {
        newData = parentBlock.content.aside || [];
      } else {
        newData =
          parentBlock.content[parentItem.group][parentItem.indexItem].children;
      }
    }
    // End children actions

    const block = newData.filter(b => b.type === type && b.sort === sort).pop();

    switch (action) {
      case 'aside':
        parent.openAddPopup(null, { type, sort, itemIndex, group }, true);
        break;

      case 'child':
        parent.openAddPopup(null, { type, sort, itemIndex, group });
        break;

      case 'up':
        newData.forEach((block, index) => {
          if (block.sort === sort && block.type === type) {
            // sort start from 10, then index, not index-1
            newData[index].sort = index * 10 - 1;
          }
        });
        break;

      case 'down':
        newData.forEach((block, index) => {
          if (block.sort === sort && block.type === type) {
            // sort start from 10, then index+2, not index+1
            newData[index].sort = (index + 2) * 10 + 1;
          }
        });
        break;

      case 'edit':
        $.magnificPopup.open({
          items: {
            src: '#popup',
            type: 'inline',
          },
          removalDelay: 250,
          closeOnBgClick: false,
          enableEscapeKey: false,
          mainClass: 'mfp-anim',
          callbacks: {
            open() {
              render(
                <BlockFormPopup
                  edit
                  disciplines={{ all: disciplines, free: disciplinesFree }}
                  block={block}
                  sort={sort}
                  onSave={block => {
                    if (
                      block.content?.group_content?.every(
                        content => content?.reference?.length === 0,
                      )
                    ) {
                      alert('Введите код дисциплины из CRM');
                      return;
                    }
                    parent.editBlock(block, parentItem, aside);
                  }}
                />,
                $('#popup')[0],
              );
            },
            close() {
              render(<div />, $('#popup')[0]);
            },
          },
        });
        break;

      case 'del':
        if (confirm(`Удалить блок "${  block.label  }"?`)) {
          newData.forEach((b, index) => {
            if (b.sort === sort && b.type === type) {
              newData.splice(index, 1);
            }
          });
        }
        break;

      case 'add':
        this.openAddPopup(null, null, null, block.sort + 5);

        break;
    }

    // Sort blocks and set new sort values
    newData.sort((a, b) => (a.sort > b.sort ? 1 : b.sort > a.sort ? -1 : 0));
    newData.forEach((block, index) => {
      newData[index].sort = (index + 1) * 10;
    });

    // If children actions
    if (parentItem) {
      if (action == 'aside' || aside) {
        globalData.forEach((b, index) => {
          if (
            b.type === parentItem.block.type &&
            b.sort === parentItem.block.sort
          ) {
            globalData[index].content.aside = newData;
          }
        });
      } else {
        globalData.forEach((b, index) => {
          if (
            b.type === parentItem.block.type &&
            b.sort === parentItem.block.sort
          ) {
            globalData[index].content[parentItem.group][
              parentItem.indexItem
            ].children = newData;
          }
        });
      }

      this.setState({ data: globalData });

      // End children actions
    } else {
      this.setState({ data: newData });
    }
  }

  onDebug() {
    const { data } = this.state;
    navigator.clipboard
      .writeText(JSON.stringify(data))
      .then(() => {
        // TODO: veracode
        alert('Данные отладки скопированы в буфер');
      })
      .catch(err => {});
  }

  prepareHtmlToSave() {
    const { page } = this.props;

    $('#page-editor').append(
      `<div id="tmp-html">${  $('#page-editor').html()  }</div>`,
    );

    // Contacts
    $('.course-contacts__container')
      .attr('id', 'aside-contacts')
      .attr('data-page', page)
      .removeAttr('class');
    // .html('');

    // Popups
    $('.simple-popups').addClass('for-users');

    $('#tmp-html .for-admin').remove();
    $('#tmp-html .simple-spoiler').removeClass('is-active');
    const html = $('#tmp-html').html();
    $('#tmp-html').remove();
    return html;
  }

  saveAllData() {
    const { page } = this.props;
    const { data } = this.state;
    const parent = this;
    const headers = {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        PROPERTY_DESIGNER_VALUE: data,
        PROPERTY_DESIGNER_HTML_VALUE: this.prepareHtmlToSave(),
      }),
    };
    fetch(`${routes.designer.update}${page}`, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          // TODO: veracode
          alert('Успешно сохранено');
          // Contacts return back
          $('#aside-contacts')
            .addClass('course-contacts__container')
            .removeAttr('data-page')
            .removeAttr('id');
          // Popups return back
          $('.simple-popups').removeClass('for-users');
        }
      })
      .catch(error => {});
  }

  render() {
    const { data, loading, error } = this.state;
    const { page } = this.props;

    if (loading) return <Loader />;

    if (error)
      return (
        <div className="container section editor-actions">
          <p className="txt txt--red">Ошибки: {error.join('; ')}</p>
        </div>
      );

    return (
      <React.Fragment>
        <AnchorMenu data={data} />
        <div className="umakhi container" id="umakhi" data-page={page}>
          <RenderBlocks
            data={data}
            onBlockAction={(
              type,
              sort,
              action,
              group = 0,
              index = 0,
              parent = null,
              aside = false,
            ) =>
              this.onBlockAction(
                type,
                sort,
                action,
                group,
                index,
                parent,
                aside,
              )
            }
          />
          <AddBlockBtn onClick={() => this.openAddPopup()} />
          <Actions
            onSave={() => this.saveAllData()}
            onCancel={() => window.location.reload()}
            onDebug={() => this.onDebug()}
          />
          <ImportStateFromDebug
            onImport={data => this.setState({ data: JSON.parse(data) })}
          />
        </div>
      </React.Fragment>
    );
  }
}
